import styled, { css } from "styled-components"
import { GlobalWrapper, SectionWrapper } from "shared/Styles/Wrappers"

import PrevIcon from "assets/img/svg/prev_white.svg"
import NextIcon from "assets/img/svg/next_white.svg"
import CloseIcon from "assets/img/svg/close.svg"

import PrevHover from "assets/img/svg/prev_white_hover.svg"
import NextHover from "assets/img/svg/next_white_hover.svg"
import CloseIconHover from "assets/img/svg/close_hover.svg"

export const Container = styled(GlobalWrapper)`
  max-width: 100vw;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(86, 24, 164, 0.9);
  z-index: 10000;
  backdrop-filter: blur(10px);
  min-height: 320px;
`

export const Wrapper = styled(SectionWrapper)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  display: flex;
  align-items: center;
`

export const ButtonWrapper = styled.div`
  width: 84px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 60px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    display: none;
  }
`

export const ImageWrapper = styled.div`
  width: calc(100% - 2 * 84px);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .swiper-container {
    width: 100%;
    .swiper-wrapper {
      width: 100%;
      height: 100%;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: calc(100% - 120px);
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: 100%;
  }
`

const defaultButton = css`
  width: 50px;
  height: 50px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: 0.2s background-image ease;
  cursor: pointer;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 40px;
    height: 40px;
  }
`

export const PrevImage = styled.div`
  background-image: url(${PrevIcon});
  ${defaultButton}
  &:hover {
    background-image: url(${PrevHover});
  }
`

export const NextImage = styled.div`
  background-image: url(${NextIcon});
  ${defaultButton}
  &:hover {
    background-image: url(${NextHover});
  }
`

export const ImageBox = styled.div`
  width: 100%;
  height: 100%;
  padding: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  .gatsby-image-wrapper {
    width: 100%;
    height: auto;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 24px;
  }
`

export const Title = styled.div`
  height: 160px;
  font-size: 30px;
  font-family: "Caveat", sans-serif;
  font-weight: 700;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 24px;
    padding-top: 80px;
    @media (orientation: landscape) {
      padding-top: 0;
    }
  }
`

export const Pagination = styled.div`
  height: 160px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    display: inline-block;
    margin: 0 4px;
    font-size: 20px;
    font-family: "Caveat", sans-serif;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding-bottom: 80px;
    font-size: 16px;
    @media (orientation: landscape) {
      padding-bottom: 0;
    }
  }
`

export const Close = styled.div`
  position: absolute;
  top: 48px;
  right: 48px;
  background-image: url(${CloseIcon});
  z-index: 3;
  ${defaultButton}
  width: 30px;
  height: 30px;

  &:hover {
    background-image: url(${CloseIconHover});
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    top: 24px;
    right: 24px;
    width: 24px;
    height: 24px;
  }
`
